import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@do/app-base-components';
import { RoleDto } from '@do/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable({ providedIn: 'root' })
export class RoleApiClient extends BaseCRUDApiClient<RoleDto> {
  baseUrl = this.config.apiEndpoint + '/role';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
